import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import { JSX, PropsWithChildren } from 'react';

//create rtl cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

const cacheLtr = createCache({
  key: 'muiltr',
});

interface PropsWithRtlIndication extends PropsWithChildren {
  isRtl?: boolean;
}

export const RtlProvider = (props: PropsWithRtlIndication): JSX.Element => {
  return <CacheProvider value={props.isRtl ? cacheRtl : cacheLtr}>{props.children}</CacheProvider>;
};
